module.exports = __webpack_public_path__ + "static/media/real-state-white.20b06d8d.svg";